import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { UPCOMING_PAYMENTS } from "./apiRoutes";

// Define the expected response type
interface UpcomingPayment {
  schoolName: string;
  expectedInvoiceClearanceDate: string;
  invoiceOwner: string;
  installmentStatus: string;
}

interface UpcomingPaymentsResponse {
  data: { items: UpcomingPayment[] };
}

const fetchUpcomingPayments = async () => {
  const response = await axiosAuth.get<UpcomingPaymentsResponse>(UPCOMING_PAYMENTS);
  return response.data;
};

export const useGetUpcomingPaymentsQuery = (
  queryParams?: UseQueryOptions<UpcomingPaymentsResponse, Error, UpcomingPaymentsResponse, ["upcomingPayments"]>
) =>
  useQuery<UpcomingPaymentsResponse, Error, UpcomingPaymentsResponse, ["upcomingPayments"]>({
    queryKey: ["upcomingPayments"],
    queryFn: fetchUpcomingPayments,
    ...(queryParams as any),
  });
